export const RA_LIST_CUSTOM_STYLE = {
    '& .RaList-actions': {
        'background-color': 'none',
        'border-top-right-radius': '8px',
        'border-top-left-radius': '8px',
        'padding-left': '10px',
        'padding-right': '10px',
        'justify-content': 'flex-start',
        'align-items': 'center',
    },
    '& .RaFilter-form': {
        'flex': 'unset'
    },
    '& .MuiToolbar-root': {
        'flex': '1',
        'justify-content': 'space-between',
    },
    '& .RaList-content': {
        'box-shadow': '1px 1px 0px 1px rgba(0, 0, 0, 0.1)',
        'border-top-right-radius': '0px',
        'border-top-left-radius': '0px',
    },
    '& .column-totalInvestmentFormatted': {'text-align': 'right'},
    '& .RaDatagrid-rowEven': {'background-color': '#FAFAFA'},
    '& .RaDatagrid-rowOdd': {'background-color': '#fff'},
    '& .RaDatagrid-row': {'height': '50px'},
    '& .MuiSvgIcon-colorDisabled': {'color': 'black', 'fill': 'black'},
    '& .MuiSvgIcon-root': {'color': 'black', 'fill': 'black'},
    '& .MuiButton-root': {
        'text-transform': 'none',
        'color': 'black',
    },
    '& .MuiTableSortLabel-root span': {
        'font-weight': 'bolder',
        'font-size': '14px',
    }
}